<template>
<div>
    <Modal v-model="visible" width="1400px" title="发起签署合同" :footer-hide="true" :mask-closable="false" class="my-modal">
        <contract-list :fileList="fileList"></contract-list>
        <div class="ivu-modal-footer">
            <Button type="text" @click="cancel">上一步</Button>
            <Button type="primary" @click="submit" :loading="loading">发起签署</Button>
        </div>
    </Modal>
</div>
    
</template>

<script>
import contractList from './contractList';
export default {
    components: {contractList},
    props: [],
    data() {
        return {
            tabId:"",
            fileList: [],
            visible: false,
            loading: false,
            data:{},
        };
    },
    created() {},
    methods: {
        open(data = {}, fileList) {
            this.data = data;
            console.log(fileList)
            this.fileList = fileList;
            this.visible = true;
        },
        submit() {
            this.loading = true;
            this.$http({
                url: '/buz/entryUserAuth/signOnlineContract',
                type: 'POST',
                data: {
                    id:this.data.id,
                },
            }).then(res => {
                this.loading = false;
                this.$notice.success('提交成功'); 
                this.visible = false;
                this.$emit('success')
            })
        },
        cancel(){
            this.visible = false;
            this.loading = false;
            this.$emit('cancel')
        }
    }
};
</script>
<style lang="scss" scoped></style>
